/**
 * Mega nav: clones each `mega-nav-category` section into the frame slots
 * (by menu position number) and drives open/close + mobile drill-in
 */
(function () {
  'use strict';

  /* ===== Assembly: clone category sources into the frame slots ===== */

  function collectSources() {
    const map = {};
    document.querySelectorAll('[data-mega-source]').forEach(function (src) {
      map[src.getAttribute('data-mega-source')] = src;
    });
    return map;
  }

  function fill(slot, sourceChild, requireChildren) {
    if (sourceChild && (!requireChildren || sourceChild.children.length > 0)) {
      slot.innerHTML = sourceChild.innerHTML;
    } else if (requireChildren) {
      slot.innerHTML = '';
    }
  }

  function assemble() {
    const sources = collectSources();

    document.querySelectorAll('[data-mega-cards]').forEach(function (slot) {
      const src = sources[slot.getAttribute('data-mega-cards')];
      fill(slot, src && src.querySelector('[data-mega-source-cards]'), true);
    });

    document.querySelectorAll('[data-mega-sub-cards]').forEach(function (slot) {
      const src = sources[slot.getAttribute('data-mega-sub-cards')];
      fill(slot, src && src.querySelector('[data-mega-source-sub-cards]'), true);
    });

    // Thumbnail: only override the server-rendered fallback when a source provides one
    document.querySelectorAll('[data-mega-thumb]').forEach(function (slot) {
      const src = sources[slot.getAttribute('data-mega-thumb')];
      const thumb = src && src.querySelector('[data-mega-source-thumb]');
      if (thumb) slot.innerHTML = thumb.innerHTML;
    });
  }

  /* ===== Desktop bar: open/close (click) ===== */

  let activeKey = null;

  function panels() {
    return document.querySelectorAll('.mega-nav [data-mega-panel]');
  }
  function triggers() {
    return document.querySelectorAll('.mega-nav [data-mega-trigger]');
  }

  function openPanel(key) {
    let matched = false;
    panels().forEach(function (panel) {
      const isMatch = panel.dataset.megaPanel === key;
      panel.hidden = !isMatch;
      if (isMatch) matched = true;
    });
    if (!matched) return;
    triggers().forEach(function (trig) {
      trig.setAttribute('aria-expanded', String(trig.dataset.megaTrigger === key));
    });
    activeKey = key;
  }

  function closeAll() {
    panels().forEach(function (panel) { panel.hidden = true; });
    triggers().forEach(function (trig) { trig.setAttribute('aria-expanded', 'false'); });
    activeKey = null;
  }

  // Open the panel that owns a given source key (menu position; used by the Theme Editor)
  function openPanelByKey(key) {
    const slots = document.querySelectorAll('.mega-nav [data-mega-cards]');
    for (let i = 0; i < slots.length; i++) {
      if (slots[i].getAttribute('data-mega-cards') === key) {
        const panel = slots[i].closest('[data-mega-panel]');
        if (panel) openPanel(panel.dataset.megaPanel);
        return;
      }
    }
  }

  function wireDesktop() {
    const root = document.querySelector('.mega-nav');
    if (!root || root.dataset.megaWired === '1') return;
    root.dataset.megaWired = '1';

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-mega-close]')) {
        e.preventDefault();
        closeAll();
        return;
      }
      const trig = e.target.closest('[data-mega-trigger]');
      if (trig) {
        e.preventDefault();
        const key = trig.dataset.megaTrigger;
        if (key === activeKey) closeAll();
        else openPanel(key);
      }
    });

    document.addEventListener('click', function (e) {
      if (activeKey === null) return;
      if (root.contains(e.target)) return;
      closeAll();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }

  /* ===== Mobile drawer: open/close + drill-in ===== */

  function setMobileOpen(open) {
    if (open) {
      document.body.dataset.mobileMenu = 'open';
    } else {
      delete document.body.dataset.mobileMenu;
      showMobileRoot();
    }
    document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', String(open));
    });
    const modal = document.getElementById('mobile-menu-modal');
    if (modal) modal.setAttribute('aria-hidden', String(!open));
  }

  function showMobileSubpanel(key) {
    document.querySelectorAll('[data-mobile-subpanel]').forEach(function (p) {
      p.hidden = p.dataset.mobileSubpanel !== key;
    });
    document.querySelectorAll('[data-mobile-cat-trigger]').forEach(function (trig) {
      trig.setAttribute('aria-expanded', String(trig.dataset.mobileCatTrigger === key));
    });
  }

  function showMobileRoot() {
    document.querySelectorAll('[data-mobile-subpanel]').forEach(function (p) { p.hidden = true; });
    document.querySelectorAll('[data-mobile-cat-trigger]').forEach(function (trig) {
      trig.setAttribute('aria-expanded', 'false');
    });
  }

  function wireMobile() {
    if (document.body.dataset.megaMobileWired === '1') return;
    document.body.dataset.megaMobileWired = '1';

    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-mobile-menu-toggle]');
      if (toggle) {
        e.preventDefault();
        setMobileOpen(document.body.dataset.mobileMenu !== 'open');
        return;
      }
      const closer = e.target.closest('[data-mobile-menu-close]');
      if (closer) {
        e.preventDefault();
        setMobileOpen(false);
        return;
      }
      const catTrigger = e.target.closest('[data-mobile-cat-trigger]');
      if (catTrigger) {
        e.preventDefault();
        showMobileSubpanel(catTrigger.dataset.mobileCatTrigger);
        return;
      }
      const back = e.target.closest('[data-mobile-back]');
      if (back) {
        e.preventDefault();
        showMobileRoot();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.dataset.mobileMenu === 'open') setMobileOpen(false);
    });
  }

  function wireAccordions() {
    if (document.body.dataset.megaAccordionsWired === '1') return;
    document.body.dataset.megaAccordionsWired = '1';

    document.addEventListener('toggle', function (e) {
      const detail = e.target;
      if (!(detail instanceof HTMLElement)) return;
      if (!detail.classList.contains('mobile-menu-modal__sub-col')) return;
      if (!detail.open) return;
      document.querySelectorAll('.mobile-menu-modal__sub-col[open]').forEach(function (other) {
        if (other !== detail) other.open = false;
      });
      const summary = detail.querySelector('.mobile-menu-modal__sub-title');
      if (!summary) return;
      requestAnimationFrame(function () {
        summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }, true);
  }

  /* ===== Init + Theme Editor hooks ===== */

  function init() {
    assemble();
    wireDesktop();
    wireMobile();
    wireAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor: a section was (re)rendered — re-clone, and re-wire the frame if it changed
  document.addEventListener('shopify:section:load', function (e) {
    assemble();
    const root = (e.target && e.target.querySelector)
      ? e.target.querySelector('.mega-nav')
      : null;
    if (root) {
      root.dataset.megaWired = '';
      wireDesktop();
    }
  });

  document.addEventListener('shopify:section:unload', function () {
    assemble();
  });

  // Theme Editor: selecting a category section (or one of its cards) opens its dropdown
  function openForSelected(target) {
    if (!target || !target.querySelector) return;
    const source = target.querySelector('[data-mega-source]') ||
      (target.closest ? target.closest('[data-mega-source]') : null);
    if (source) openPanelByKey(source.getAttribute('data-mega-source'));
  }
  document.addEventListener('shopify:section:select', function (e) { openForSelected(e.target); });
  document.addEventListener('shopify:block:select', function (e) { openForSelected(e.target); });
  document.addEventListener('shopify:section:deselect', function () { closeAll(); });
})();
